module.exports = __webpack_public_path__ + "static/media/icon_119.b28e66ed.svg";